// extracted by mini-css-extract-plugin
module.exports = {"container":"Hero_container__3pafB","image":"Hero_image__2AbVN","headers":"Hero_headers__1ebVo","header":"Hero_header__rypkM","imageContainer":"Hero_imageContainer__sGqrX"};